module.exports = __webpack_public_path__ + "img/SG.0406420b.svg";